import React from "react";
import styles from "./TotalAnimalTable.module.css";

interface AnimalData {
  key: number;
  animal: string;
  count: number;
}

const dataSource: AnimalData[] = [
  {
    key: 1,
    animal: "Производство молока",
    count: 1777.6,
  },
  {
    key: 2,
    animal: "Производство шерсти в физческом весе",
    count: 12914,
  },
  {
    key: 3,
    animal: "Производство яиц",
    count: 685,
  },
  {
    key: 4,
    animal: "Производство мяса в убойном весе",
    count: 252.5,
  },

];

export const TotaltypesOfproducts: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.container_inner}>
        <h2>Данные по животным</h2>
        <ul className={styles.table}>
          <li className={styles.header}>
            <span className={styles.cell}>Наименование показателей
            </span>
            <span className={styles.cell}>тонн</span>
          </li>
          {dataSource.map((item) => (
            <li key={item.key} className={styles.row}>
              <span className={styles.cell}>{item.animal}</span>
              <span className={styles.cell}>{item.count.toLocaleString()}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};


